import React from "react";
import fileImage2 from "../../../../../assets/images/DeathModuleNew/fileuploaded.png";
import fileImage from "../../../../../assets/images/DeathModuleNew/startmessage.png";
import addIcon from "../../../../../assets/images/DeathModuleNew/addIcon.png";
import NewLoader from "../../../../../components/styled-components/loader/NewLoader";
import moment from "moment";
import linkIcon from "../../../../../assets/SVGs/linkIcon.svg";
import linkIconDark from "../../../../../assets/SVGs/linkIconDark.svg";
import { setActiveStep } from "../../../../../redux/slices/loginSlice";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import "../../../disability/DisabilityDashboard/styles/disbilityDashboardStyle.css"
import { ToolTipCreator } from "../../../../../helpers/ToolTipCreator";

export const DisasterDocumentDisplayCard = ({
  step,
  fileUpload,
  loading,
  documents,
  moduleData,
  width
}) => {
  const dispatch = useDispatch();
  const history = useHistory();

  return (
    <div className="DisabilityCardMain" style={{ position: "relative",width:width ? width : "" }}>
      <div className="cardHeadingDisability">
        <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
          {moduleData.Icon &&<img
            width={66}
            height={56}
            src={moduleData.Icon}
            alt={moduleData.name}
          ></img>}
          {/* {moduleData.name} */}
          <div style={{ display: "flex", alignItems: "baseline", columnGap: "3px" }}>
            {moduleData.name}
            {moduleData &&
              moduleData.tooltip &&
              ["Personal & Family Information"].includes(moduleData.name) && (
                <ToolTipCreator name={moduleData.tooltip} />
            )}  
            </div>        
        </div>
        <div className="uploadButtonsDisability">
          {" "}
          <div
            className="upload"
            style={{ width: "20px", height: "20px" }}
            onClick={() => {
              dispatch(setActiveStep(step));
              history.push("/protector/disaster");
            }}
          >
            <img
              src={addIcon}
              width={12}
              height={12}
              style={{ width: "12px", height: "12px" }}
              alt="addicon"
            ></img>
          </div>
        </div>
      </div>
      <div className="cardDisabilityDesc">{moduleData.Purpose}</div>
      {fileUpload && fileUpload ? (
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "8px",
            alignItems: "center",
          }}
        >
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              background: "#E1E4F3",
              borderRadius: "50%",
              width: "fit-content",
              padding: "8px",
            }}
          >
            <img
              src={documents && documents.length > 0 ? linkIconDark : linkIcon}
              height={24}
              width={24}
              alt="fileImage"
            ></img>
          </div>
          {documents && documents.length > 0 && (
            <span style={{ color: "#2C419D", fontWeight: "bold" }}>
              {documents && documents.length}
            </span>
          )}
        </div>
      ) : (
        "No File Uploaded"
      )}
      <NewLoader isLoading={loading} />
    </div>
  );
};
